import React from "react";
import "./BridalMakeUpAbout.css";
const BridalMakeUpAbout = () => {
  return (
    <div className="bridalMakeUpAbout">
      <h2>
        Bridal Services at SCENT
      </h2>
      <p>
        Prepare for your big day with SCENT's Bridal Services! Look your
        absolute best even before your D-Day with our exclusive pre-bridal
        services. Visit our salon and indulge in tailored treatments designed to
        enhance your beauty and confidence. Take advantage of our special offers
        on pre-bridal services and ensure you glow with radiance on your wedding
        day. Trust SCENT to make every moment leading up to your special day
        memorable and beautiful.
      </p>
    </div>
  );
};

export default BridalMakeUpAbout;
